import React, { useState, useEffect, lazy, Suspense } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Loader from './components/common/Loader';
import Home from './pages';
import { Analytics } from "@vercel/analytics/react";

const AboutPage = lazy(() => import('./pages/innerpages/about'));
const ContactPage = lazy(() => import('./pages/innerpages/contact'));
const PortfolioPage = lazy(() => import('./pages/innerpages/portfolio'));
const ServicesPage = lazy(() => import('./pages/innerpages/services'));
const ProductDetailsPage = lazy(() => import('./pages/innerpages/product-details'));
const CollectionPage = lazy(() => import('./pages/innerpages/collection'));

function RouteFallback() {
  return (
    <div
      className="route-fallback d-flex align-items-center justify-content-center"
      style={{ minHeight: '50vh' }}
      aria-busy="true"
      aria-live="polite"
    >
      <span className="fsz-14 color-666">Loading…</span>
    </div>
  );
}

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Immediately set to top
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    window.scrollTo(0, 0);

    // Some custom scroll plugins (like GSAP/ScrollSmoother) initialize slightly delayed
    // and might cache the old scroll position. This timeout ensures the page stays at the top.
    setTimeout(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0);
    }, 150);
  }, [pathname]);

  return null;
}

function App() {
  const [showLoader, setShowLoader] = useState(true);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const timer1 = setTimeout(() => setIsClosing(true), 1800);
    const timer2 = setTimeout(() => setShowLoader(false), 3000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  }, []);
  
  return (
    <Router>
      <ScrollToTop />
      {showLoader && <Loader className={isClosing ? 'closing' : ''} />}
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/collection" element={<CollectionPage />} />
          <Route path="/product/:categoryId/:seriesTitle" element={<ProductDetailsPage />} />
        </Routes>
      </Suspense>
      <Analytics />
    </Router>
  );
}

export default App;
